
import { ReactNode } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { SidebarInset } from "@/components/ui/sidebar";
import HuggyWidget from "@/components/chat/HuggyWidget";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <SidebarInset className="transition-all duration-300 ease-in-out">
          <div className="p-4 md:p-6 lg:p-8">
            {children}
          </div>
        </SidebarInset>
      </div>
      
      {/* Huggy Chat Widget - Etapa 1: habilitado para testar */}
      <HuggyWidget enabled={true} />
    </SidebarProvider>
  );
};

export default Layout;
